<template>
  <div class="table-wrapper">
    <div class="datatable-controls d-flex justify-content-between align-items-center mb-2">
      <div class="datatable-length"></div>
      <div class="datatable-search"></div>
    </div>
    <table
      :id="props.tableId"
      ref="tableRef"
      class="table table-striped table-bordered w-100"
    >
      <slot></slot>
    </table>
  </div>
</template>

<script setup>
  import { onMounted, ref, onBeforeUnmount, defineProps, nextTick } from 'vue';

  const props = defineProps(['tableId']);
  const tableRef = ref(null);

  onMounted(() => {
    window.dt_opts = {
      paging: true,
      pageLength: 10,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      responsive: true,
      // your DOM structure already gives us a flex parent on the bottom row
      dom: '<"datatable-controls d-flex justify-content-between align-items-center mb-2 mt-5"lfr>t<"d-flex justify-content-between align-items-center mt-2"ip>',
      language: {
        paginate: {
          previous: '<i class="fas fa-arrow-left"></i>',
          next: '<i class="fas fa-arrow-right"></i>'
        },
        info: 'Showing _START_ to _END_ of _TOTAL_ entries',
        lengthMenu: 'Show _MENU_ entries',
        search: 'Search:',
        emptyTable: 'No data available in table'
      }
    };

  //   // if using server side pagination.
  //   window.dt_opts = {
  //   paging: false,
  //   lengthChange: false,
  //   searching: false,
  //   ordering: false,
  //   info: false,
  //   responsive: true,
  //   dom: 't',
  // };

  nextTick(() => {
    const el = tableRef.value;
    if (el && !$.fn.dataTable.isDataTable(el)) {
      $(el).DataTable(window.dt_opts);
    }
  });
});

  onBeforeUnmount(() => {
    const el = tableRef.value;
    if (el && $.fn.dataTable.isDataTable(el)) {
      $(el).DataTable().destroy();
    }
  });
</script>

<style scoped>
  :deep(.dataTables_wrapper .dataTables_info),
  :deep(.dataTables_wrapper .dataTables_paginate),
  :deep(.dataTables_wrapper .dataTables_length) {
    float: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :deep(.dataTables_wrapper > div.d-flex.justify-content-between.align-items-center.mt-2) {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
    gap: 10px;
  }

  :deep(.dataTables_wrapper .dataTables_info) {
    white-space: nowrap;
    padding-right: 15px;
    font-size: 12px;
    color: #495057;
    font-weight: 600;
  }

  :deep(.dataTables_wrapper .dataTables_paginate) {
    margin-left: auto !important;
  }

  :deep(.dataTables_wrapper .dataTables_paginate ul.pagination) {
    display: flex;
    gap: 5px;
  }
</style>

